import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { ApiHttpService } from './api-http.service'

import { ApplicationVersion } from '../entities/application.entity'

@Injectable({
  providedIn: 'root',
})
export class ResourceHistoryApiService extends ApiHttpService {
  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)

    super(baseUrl, httpClient)
  }

  getResourceHistory(
    appId: string,
    appVersionId: string,
    resourceDefinitionId: string
  ): Observable<
    { applicationVersion: ApplicationVersion; resourceId: string; resourceName: string }[]
  > {
    return this.get(
      `appmanager/api/app/${appId}/app-version/${appVersionId}/changes-history/rdi/${resourceDefinitionId}`
    )
  }
}
